import { create } from "zustand";
import {
  MetaTagsFormData,
  MetaTagsResult,
} from "../features/meta-tags-generator/components/types";

export interface ToolsState {
  showResult: boolean;
  setShowResult: (showResult: boolean) => void;

  formData?: MetaTagsFormData;
  setFormData: (formData: MetaTagsFormData) => void;

  result: MetaTagsResult[];
  setResult: (result: MetaTagsResult[]) => void;
  //updateResult: (result: MetaTagsResult, index: number) => void

  content: string;
  aiPercentage: number | null;
  seoGrade: string;
  optimizedContent: string | null;
  isLoading: boolean;
  minLengthError: string | null;
  setContent: (content: string) => void;
  setAiPercentage: (percentage: number | null) => void;
  setSeoGrade: (grade: string) => void;
  setOptimizedContent: (optimizedContent: string | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  setMinLengthError: (error: string | null) => void;
}

export const useToolsStore = create<ToolsState>()((set) => ({
  showResult: false,
  setShowResult: (showResult: boolean) =>
    set((state) => ({ showResult: showResult })),
  formData: {
    header: {
      creativity: "",
      results: 0,
      websiteName: "",
    },
    urlKeywords: [
      {
        keywords: "",
        websiteUrl: "",
        isValid: true,
      },
    ],
  },
  // updateResult: (result1: MetaTagsResult, index: number) =>
  //     set((state) => {
  //         const newResults = [...state.result];
  //         const newIndex: any = result1.index

  //         newResults[newIndex] = result1;

  //         return { result: newResults };
  //     }),
  setFormData: (formData: MetaTagsFormData) =>
    set((state) => ({ formData: formData })),
  result: [],
  setResult: (result: MetaTagsResult[]) => set((state) => ({ result: result })),

  content: "",
  aiPercentage: null,
  seoGrade: "",
  optimizedContent: null,
  isLoading: false,
  minLengthError: null,
  setContent: (content: string) => set((state) => ({ content })),
  setAiPercentage: (percentage: number | null) =>
    set((state) => ({ aiPercentage: percentage })),
  setSeoGrade: (grade: string) => set((state) => ({ seoGrade: grade })),
  setOptimizedContent: (optimizedContent: string | null) =>
    set((state) => ({ optimizedContent })),
  setIsLoading: (isLoading: boolean) => set((state) => ({ isLoading })),
  setMinLengthError: (error: string | null) =>
    set((state) => ({ minLengthError: error })),
}));
